// CRUZ NEWS VIZ の関心まわりで叩く JSON の共通部分。
// 未ログインで押された時は 401 が返るので、ログイン画面へ送って戻れるようにする。
// 仕様: docs/design/news-personalization.md
export async function postJson(url, { method = "POST", body = null, loginPath = "/login" } = {}) {
  const token = document.querySelector('meta[name="csrf-token"]')?.content || ""
  const res = await fetch(url, {
    method,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": token
    },
    credentials: "same-origin",
    body: body ? JSON.stringify(body) : null
  })

  if (res.status === 401) {
    window.location.href = `${loginPath}?return_to=${encodeURIComponent(window.location.pathname + window.location.search)}`
    return null
  }
  return res.json()
}
